import RfmModalBase from "./RfmModalBase";


export default function RfmDeleteZoneModal({ open, onClose, zone, onDelete }) {
    return (
        <RfmModalBase
            open={open}
            title="Eliminar Zona"
            onClose={onClose}
            footer={
                <>
                    <button className="rfm-btn rfm-btn-secondary" type="button" onClick={onClose}>
                        Cancelar
                    </button>
                    <button className="rfm-btn rfm-btn-danger" type="button" onClick={() => onDelete?.(zone?.id)}>
                        <i className="bi bi-trash" /> Eliminar
                    </button>
                </>
            }
        >
            <p>¿Estás seguro que deseas eliminar la zona <strong>{zone?.name}</strong>? Esta acción no se puede deshacer.</p>
        </RfmModalBase>
    );
}